import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

export const MAIN_SITE = "https://www.penda.org.mk/";

// Link back to Penda's main website, shown at the top of every page.
export default function MainSiteLink({ className = "" }) {
  const { t } = useTranslation();
  return (
    <a href={MAIN_SITE} title={t("common.main_site")} data-testid="main-site-link"
      className={`inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors ${className}`}>
      <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> penda.org.mk
    </a>
  );
}
